import axios from 'axios';

const API_URL = '/api/careteam'

export const getMembers = async (user_id) => {
    const res = await axios.get(API_URL, {
        params: {user_id}
    });

    return res.data;
}

export const createMember = async ({user_id, role, name, phone, fax, location, hours}) => {
    const res = await axios.post(API_URL, { user_id, role, name, phone, fax, location, hours });

    return res.data;
}

export const deleteMember = async (id) => {
    const res = await axios.delete(`${API_URL}/${id}`);

    return res.data;
}

export const updateMember = async (id, { user_id, role, name, phone, fax, location, hours }) => {
    const res = await axios.put(`${API_URL}/${id}`, { user_id, role, name, phone, fax, location, hours });

    return res.data;
}